import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCloudArrowUp12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCloudArrowUp12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m10.058 5.568-.064.538.416.348c.37.31.59.75.59 1.23 0 .87-.75 1.65-1.77 1.65H2.77C1.75 9.333 1 8.553 1 7.683c0-.593.339-1.134.884-1.43l.607-.328-.092-.684a2 2 0 0 1-.014-.209c0-.87.75-1.65 1.769-1.65q.146 0 .284.021l.442.067.345-.286A3 3 0 0 1 7.154 2.5c1.656 0 2.923 1.274 2.923 2.754q0 .16-.019.314m-.827 4.765H2.769C1.24 10.333 0 9.147 0 7.683c0-.99.567-1.853 1.408-2.308a3 3 0 0 1-.023-.342c0-1.463 1.24-2.65 2.769-2.65q.221 0 .433.032A4 4 0 0 1 7.154 1.5c2.167 0 3.923 1.68 3.923 3.754q0 .219-.026.433c.582.485.949 1.2.949 1.996 0 1.464-1.24 2.65-2.77 2.65M4.233 6.475a.5.5 0 0 1 0-.707l1.414-1.414L6 4l.354.354 1.414 1.414a.5.5 0 0 1-.707.707L6.5 5.914v2.183a.5.5 0 1 1-1 0V5.915l-.56.56a.5.5 0 0 1-.707 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCloudArrowUp12);
